// removed by extract-text-webpack-plugin
module.exports = {"transactions":"transactions__transactions___zbIkq","activity":"transactions__activity___23INv","transaction-row":"transactions__transaction-row___1Ro8_","transaction-row-last":"transactions__transaction-row-last___1h_ul","transaction-row-last--green":"transactions__transaction-row-last--green___205sF","transaction-row--green":"transactions__transaction-row--green___1dbY_","transaction-row-left":"transactions__transaction-row-left___wuehb","item":"transactions__item___1CeNe","transaction-row-right":"transactions__transaction-row-right___2l1VN","bold":"transactions__bold___3hUxK"};


//////////////////
// WEBPACK FOOTER
// ./src/card/transaction/transactionsList/transactions.scss
// module id = 1226
// module chunks = 0